import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';

import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';

const editableLabelStyles = theme => ({
    container: {
        flexWrap: 'wrap',
    },
    row: {
        width: '100%',
        display: 'flex',
        height: '36px',
    },
    textField: {
        width: '50%',
        height: '36px',
        marginTop: '0px',
    },
    spaceLeft: {
        paddingTop: 5,
    },
    textLabel: {
        marginTop: 2,
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        paddingRight: theme.spacing(1),
    },
    defaultIconButton: {
        color: theme.palette.text.secondary,
    },
});

class EditableLabel extends React.Component {
    state = {
        canEdit: false,
    };

    handleEditModeStatusChange = () => {
        this.setState({ canEdit: !this.state.canEdit });
    };

    render() {
        const {
            classes,
            groupInfo,
            groupInfoErrors,
            onChange,
            autoFocus,
        } = this.props;

        return (
            <div className={classes.container}>
                <div className={classes.row}>
                    {this.state.canEdit === true && (
                        <TextField
                            error={Boolean(groupInfoErrors.name)}
                            required
                            value={groupInfo.name}
                            onChange={event =>
                                onChange('name', event.target.value)
                            }
                            className={classNames(
                                classes.textField,
                                classes.spaceRight
                            )}
                            helperText={groupInfoErrors.name}
                            margin="normal"
                            variant="outlined"
                            autoFocus={autoFocus}
                        />
                    )}
                    {this.state.canEdit === false && (
                        <Tooltip
                            title={groupInfo.name}
                            placement="bottom-start"
                        >
                            <div className={classes.textLabel}>
                                {groupInfo.name}
                            </div>
                        </Tooltip>
                    )}
                    <Button
                        className={classes.defaultIconButton}
                        onClick={this.handleEditModeStatusChange}
                    >
                        <Icon>edit_icon</Icon>
                    </Button>
                </div>
            </div>
        );
    }
}

export default withStyles(editableLabelStyles)(EditableLabel);
